import React from 'react';

export default function MethodSelection({ onMethodSelect }) {
  const methods = [
    {
      id: 'authenticator',
      name: 'Authenticator App',
      description: 'Use Google Authenticator, Authy, or similar apps to generate verification codes',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
      securityLevel: 'High',
      recommended: true
    },
    {
      id: 'sms',
      name: 'SMS Verification',
      description: 'Receive verification codes via text message to your mobile phone',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
        </svg>
      ),
      securityLevel: 'Medium',
      recommended: false
    },
    {
      id: 'hardware',
      name: 'Hardware Security Key',
      description: 'Use a physical security key that supports FIDO2/WebAuthn standards',
      icon: (
        <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      ),
      securityLevel: 'Very High',
      recommended: false,
      comingSoon: true
    }
  ];

  const getSecurityLevelColor = (level) => {
    switch (level) {
      case 'Very High':
        return 'text-green-600 bg-green-100';
      case 'High':
        return 'text-blue-600 bg-blue-100';
      case 'Medium':
        return 'text-yellow-600 bg-yellow-100';
      default:
        return 'text-gray-600 bg-gray-100';
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Choose Your Authentication Method</h2>
      <p className="text-gray-600 mb-8">Select the method you would like to use for two-factor authentication</p>
      <div className="grid gap-6 md:grid-cols-1">
        {methods?.map((method) => (
          <div
            key={method?.id}
            className={`relative border-2 rounded-lg p-6 transition-all ${
              method?.comingSoon
                ? 'border-gray-200 bg-gray-50 opacity-60 cursor-not-allowed' :'border-gray-200 hover:border-indigo-500 hover:shadow-lg cursor-pointer'
            }`}
            onClick={() => !method?.comingSoon && onMethodSelect(method?.id)}
          >
            {method?.recommended && (
              <div className="absolute top-4 right-4">
                <span className="bg-indigo-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                  Recommended
                </span>
              </div>
            )}

            {method?.comingSoon && (
              <div className="absolute top-4 right-4">
                <span className="bg-gray-400 text-white text-xs font-semibold px-3 py-1 rounded-full">
                  Coming Soon
                </span>
              </div>
            )}

            <div className="flex items-start">
              <div className="text-indigo-600 mr-4">
                {method?.icon}
              </div>

              <div className="flex-1">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{method?.name}</h3>
                <p className="text-gray-600 mb-4">{method?.description}</p>

                <div className="flex items-center">
                  <span className="text-sm font-medium text-gray-700 mr-2">Security Level:</span>
                  <span className={`text-sm font-semibold px-3 py-1 rounded-full ${getSecurityLevelColor(method?.securityLevel)}`}>
                    {method?.securityLevel}
                  </span>
                </div>
              </div>

              {!method?.comingSoon && (
                <div className="ml-4">
                  <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}